<script>
import { defineComponent } from "vue";
import SidebarRouteLink from "@kit/components/SidebarRouteLink.vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import SideNavDrawerBase from "@kit/components/SideNavDrawerBase.vue";
import { searchWidgetMobile, sideDrawer } from "@project/themes";
import { getCurrentYear } from "@kit/utils/Formats"

export default defineComponent({
  name: "SizeNavDrawer",
  setup() {
    return { searchWidgetMobile, sideDrawer, getCurrentYear };
  },
  components: {
    SideNavDrawerBase,
    SidebarRouteLink,
    NavMainSearch,
  },
});
</script>

<style>
.side-nav-1 {
  font-size: 25px;
  color: white;
}

.side-nav-1 > a {
  color: white;
  transition: 0.3s color linear;
}
.side-nav-1 > a:hover {
  color: white;
}
.side-nav-1 > a:visited {
  color: #eeeeee;
}

@media (max-width: 960px) {
}

.rvit-side-nav-drawer {
  background: linear-gradient(180deg,var(--sidenav-grad-start-color ) 0%, var(--sidenav-grad-end-color) 100%);
  opacity: 1;
}
/* 
.rvit-side-nav-drawer-vertical-repeater {
  width:10% !important;
  top:0px !important;
  bottom:0px !important;
  left:80%;
  top:0px;
  background-image: url('/cms-static-assets/2026/03/RVIT-Vertical-Repeater_white.png');
  background-repeat:repeat-y;
  background-size: contain;
  opacity: 0.2;
  border: 1px solid green;
} */

</style>

<template>
  <SideNavDrawerBase :theme="sideDrawer">
    <template #nav-items="{ active }">

      <h1 class="sb sb-text" style="color:white; margin-top:30px;">Gidutikad Paiute</h1>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/">Home</SidebarRouteLink>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">About &amp; News</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/our-history">Our History</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/calendar">Calendar</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/news">News</SidebarRouteLink>
      </div>
   
      <h3 class="sb sb-text" style="color:white; margin-top:30px;">Gov't &amp; Facilities</h3>
      
      <!-- <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government">Government</SidebarRouteLink>
      </div> -->
   
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/forms">Forms</SidebarRouteLink>
      </div>
   
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/housing">Housing</SidebarRouteLink>
      </div>
   
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/wellness-center">Wellness Center</SidebarRouteLink>
      </div>
   
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/staff">Staff</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/careers">Careers</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/contact-us">Contact</SidebarRouteLink>
      </div>    
      
      <!-- <NavMainSearch :theme="searchWidgetMobile" :active="active" /> -->
      <div class="sb sb-v side-nav-1" style="font-size:0.7rem;">
        © {{ getCurrentYear() }} FBICC
      </div>

      <!-- <div style="z-index:0;" class="sb sb-abox rvit-side-nav-drawer-vertical-repeater"></div> -->

    </template>
  </SideNavDrawerBase>
</template>
